/**
 * Create Administrators troubleshooting page.
 * Allows SuperAdmins to bulk-create platform administrators (Viewer/Editor) from a list of emails.
 * Composes email parse, preview, errors, and results subviews; access is gated for sys admins outside a portal.
 */

import { observer } from 'mobx-react-lite';

import currentAccountStore from '../../../../pages/accounts/stores/current-account-store';
import CurrentPortalStore from '../../../../stores/current-portal-store';
import CreateAdministratorsAccessDenied from './components/create-administrators-access-denied';
import CreateAdministratorsEmailParseCard from './components/create-administrators-email-parse-card';
import CreateAdministratorsPreviewCard from './components/create-administrators-preview-card';
import CreateAdministratorsErrorBanner from './components/create-administrators-error-banner';
import CreateAdministratorsResultsCard from './components/create-administrators-results-card';

import './create-administrators-page.scss';

const CreateAdministratorsPage: React.FC = observer(() => {
    const isSysAdmin = currentAccountStore.isSysAdmin;
    const portalId = CurrentPortalStore.currentPortal.id;

    if (!isSysAdmin || portalId) {
        return (
            <div className="create-administrators-page">
                <CreateAdministratorsAccessDenied />
            </div>
        );
    }

    return (
        <div className="create-administrators-page">
            <CreateAdministratorsEmailParseCard />
            <CreateAdministratorsPreviewCard />
            <CreateAdministratorsErrorBanner />
            <CreateAdministratorsResultsCard />
        </div>
    );
});

export default CreateAdministratorsPage;
